import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=6ba1b02b&"
import script from "./AffiliateList.vue?vue&type=script&lang=js&"
export * from "./AffiliateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports